import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import HowToBook from './HowToBook';

import ListingTitle from './ListingTitle';

import { ListingSectionObservable } from './ListingSection';

const ListingHowToBook = ({
  hasVetting = false,
  hasRentCollection = false
}) => (
  <ListingSectionObservable section="howToBook">
    <ListingTitle role="secondary">
      {trans('listing.how-to-book.section-main-title')}
    </ListingTitle>
    <HowToBook hasRentCollection={hasRentCollection} hasVetting={hasVetting} />
  </ListingSectionObservable>
);

ListingHowToBook.propTypes = {
  hasRentCollection: PropTypes.string,
  hasVetting: PropTypes.bool
};

export default ListingHowToBook;
